/* Sand Koi theme scripts — vanilla JS, no dependencies */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Overlays ---------- */
  function setOpen(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
  }
  var menu = function () { return $('[data-mobile-menu]'); };
  var drawer = function () { return $('[data-cart-drawer]'); };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open],[data-menu-close],[data-cart-open],[data-cart-close]');
    if (!t) return;
    if (t.hasAttribute('data-menu-open')) { e.preventDefault(); setOpen(menu(), true); }
    if (t.hasAttribute('data-menu-close')) { e.preventDefault(); setOpen(menu(), false); }
    if (t.hasAttribute('data-cart-open')) {
      if (document.body.classList.contains('template-cart') || !drawer()) return;
      e.preventDefault(); setOpen(drawer(), true);
    }
    if (t.hasAttribute('data-cart-close')) { e.preventDefault(); setOpen(drawer(), false); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setOpen(menu(), false); setOpen(drawer(), false); }
  });

  /* ---------- Cart ---------- */
  function refreshCart() {
    return fetch(window.routes.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
        var fresh = $('[data-cart-drawer-inner]', doc);
        var cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          var n = parseInt(fresh.getAttribute('data-item-count'), 10) || 0;
          $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
        }
      });
  }
  function changeLine(line, qty) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refreshCart);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b || !b.closest('[data-cart-drawer]')) return;
    e.preventDefault();
    var line = parseInt(b.getAttribute('data-line'), 10);
    var qty = parseInt(b.getAttribute('data-qty'), 10);
    b.disabled = true;
    changeLine(line, qty);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-product-form]');
    if (!f) return;
    var sub = e.submitter;
    if (!sub || !sub.hasAttribute('data-add-to-cart')) return; // let dynamic checkout buttons handle themselves
    e.preventDefault();
    var err = $('[data-form-error]', f);
    if (err) { err.hidden = true; err.textContent = ''; }
    sub.disabled = true; sub.classList.add('is-loading');
    fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status && j.status !== 200) { throw new Error(j.description || j.message || 'Could not add to cart'); }
        return refreshCart().then(function () { setOpen(drawer(), true); });
      })
      .catch(function (x) { if (err) { err.textContent = x.message; err.hidden = false; } })
      .then(function () { sub.disabled = false; sub.classList.remove('is-loading'); });
  });

  /* ---------- Quantity steppers (product + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = $('input', b.parentElement);
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', root);
    var idInput = $('input[name="id"]', form);
    var addBtn = $('[data-add-to-cart]', form);
    var priceEl = $('[data-price]', root);
    var gallery = $('[data-gallery-track]', root);
    var count = $('[data-gallery-count]', root);
    var sticky = $('[data-sticky-atc]');

    function selection() {
      var out = [];
      $$('fieldset[data-option]', root).forEach(function (fs) {
        var c = $('input:checked', fs);
        out.push(c ? c.value : null);
      });
      return out;
    }
    function find(sel) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function markAvailability(sel) {
      $$('fieldset[data-option]', root).forEach(function (fs, pos) {
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[pos] = inp.value;
          var v = find(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function setPrice(v) {
      if (!priceEl) return;
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html = '<s>' + v.compare_formatted + '</s><span class="price__now--sale">' + v.price_formatted + '</span>';
      } else { html = '<span>' + v.price_formatted + '</span>'; }
      priceEl.innerHTML = html;
    }
    function showMedia(v) {
      if (!gallery || !v || !v.featured_media_id) return;
      var el = $('[data-media-id="' + v.featured_media_id + '"]', gallery);
      if (!el) return;
      if (window.matchMedia('(min-width:900px)').matches) {
        var r = el.getBoundingClientRect();
        if (r.top < 60 || r.top > window.innerHeight - 160) {
          window.scrollTo({ top: window.scrollY + r.top - 110, behavior: 'smooth' });
        }
      } else {
        gallery.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
      }
    }
    function update(changedByUser) {
      var sel = selection();
      $$('[data-option-label]', root).forEach(function (l) {
        var i = parseInt(l.getAttribute('data-option-label'), 10) - 1;
        if (sel[i]) l.textContent = sel[i];
      });
      markAvailability(sel);
      var v = find(sel);
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        if (sticky) $('[data-sticky-btn]', sticky).disabled = true;
        return;
      }
      idInput.value = v.id;
      setPrice(v);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (sticky) {
        var sb = $('[data-sticky-btn]', sticky);
        sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out';
        var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = v.price_formatted;
      }
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      if (changedByUser) showMedia(v);
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('fieldset[data-option]')) update(true);
    });
    update(false);

    if (gallery && count) {
      gallery.addEventListener('scroll', function () {
        var w = gallery.clientWidth;
        if (!w) return;
        count.textContent = (Math.round(gallery.scrollLeft / w) + 1) + ' / ' + $$('.gallery__item', gallery).length;
      }, { passive: true });
    }
    if (sticky) {
      $('[data-sticky-btn]', sticky).addEventListener('click', function () { addBtn.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(addBtn);
      }
    }
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Recommendations ---------- */
  function loadReco() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.getAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', '1');
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var c = $('[data-recommendations]', doc);
        if (c && c.innerHTML.trim()) { el.innerHTML = c.innerHTML; el.hidden = false; }
      });
    });
  }
  loadReco();

  /* ---------- Cart page: auto-update on quantity change ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-form] input[name="updates[]"]');
    if (!input) return;
    var form = input.form;
    var btn = form.querySelector('[name="update"]');
    if (form.requestSubmit) { form.requestSubmit(btn); } else if (btn) { btn.click(); }
  });

  /* ---------- Collection filters auto-submit ---------- */
  document.addEventListener('change', function (e) {
    var f = e.target.closest('[data-filter-form]');
    if (f) f.submit();
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('in'); }); }
})();
